import type { FC } from "react";

import Skeleton from "@/components/global/SkeletonComponent/server/SkeletonComponent";
import { cn } from "@/utils/common/styleHelper/utils";

interface SkeletonPromotionBoxServerProps {
  classNames?: {
    base?: string;
  };
}

const SkeletonPromotionBoxServerComponent: FC<
  SkeletonPromotionBoxServerProps
> = ({ classNames }) => {
  return (
    <div
      className={cn(
        "relative mx-auto size-full max-w-7xl overflow-hidden",
        classNames?.base ?? "",
      )}
    >
      <div className="hidden md:block">
        <div className="flex flex-col gap-4 md:gap-6">
          <div className="flex w-full items-center justify-between">
            <div className="flex h-[39px] w-1/5 items-center">
              <Skeleton className="h-6 w-full" />
            </div>
            <div className="flex h-6 w-[15%] items-center gap-2">
              <Skeleton className="size-full" />
              <Skeleton className="min-h-6 min-w-6 rounded-full" />
            </div>
          </div>
          <div className="inline-flex items-start justify-start gap-4">
            {Array.from({ length: 3 }).map((_, index) => {
              return (
                <div
                  key={index}
                  className="flex h-[13.386rem] !w-full items-center justify-center xl:!w-[24.313rem]"
                >
                  <Skeleton className="inline-flex size-full items-center justify-center rounded-[10px]" />
                </div>
              );
            })}
          </div>
        </div>
      </div>

      <div className="block md:hidden">
        <div className="flex flex-col gap-4 md:gap-6">
          <div className="flex w-full items-center justify-between pr-4">
            <div className="flex h-[33px] w-[30%] items-center">
              <Skeleton className="h-5 w-full" />
            </div>
            <Skeleton className="min-h-6 min-w-6 rounded-full" />
          </div>
          <div className="inline-flex items-start justify-start gap-4">
            {Array.from({ length: 2 }).map((_, index) => {
              return (
                <div
                  key={index}
                  className="flex h-[170.675px] w-[310px] items-center justify-center"
                >
                  <Skeleton className="inline-flex h-[170.675px] w-[310px] items-center justify-center rounded-[10px]" />
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </div>
  );
};

export default SkeletonPromotionBoxServerComponent;
